import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrderManagementApiService from 'Service/OrderManagement/OrderManagementApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { DELETE_LINK, GET_REPORT_LIST, SAVE_CATEGORY, SAVE_LINK, GET_E1_UPLOAD_TEMPLATE_EXCEL_DATA, SET_E1_UPLOAD_TEMPLATE_EXCEL_DATA } from 'Store/Report/ReportList/ReportListType';
import { isLinkSaved, setReportList,setE1UploadTemplateExcelData } from 'Store/Report/ReportList/ReportListAction';
import AssetManagementApiService from 'Service/AssetManagement/AssetManagementApiService';

function* getReportListSaga(): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.OrderManagement,
            endpoint: `report`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData

        );

        if (response) {
            yield put(setReportList(response));
            yield put(globalLoaderText(""));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* saveLink(req: any): any {
    try {
        yield put(globalLoaderText(req?.type == SAVE_LINK ? "Saving Link...." : "Saving Category...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.OrderManagement,
            endpoint: req?.type == SAVE_LINK ? `report` : `report/category`,
            payload: req?.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData

        );
        if(response){
            yield put(setReportList(response));
            yield put(isLinkSaved(true));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(isLinkSaved(false));
        yield put(globalLoaderText(""));
    }
}

function* deleteReportLink(req: any): any {
    try {
        yield put(globalLoaderText("Deleting Report Link...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.OrderManagement,
            endpoint: `report/delete?reportId=${req?.reportId}&savedBy=${req?.savedBy}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData

        );
        if(response){
            yield put(setReportList(response));
            yield put(isLinkSaved(true));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(isLinkSaved(false));
        yield put(globalLoaderText(""));
    }
}

function* getE1UploadTemplateExcelSaga(req?: any): any {
    try {
        const savedBy = req?.payload?.savedBy;        
        yield put(globalLoaderText("Exporting Excel...."));
        
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `e1upload/template/excel?savedBy=${savedBy}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        
        const response = yield call(AssetManagementApiService.post,API_URL.PostWebApp, payloadData);

        yield put(setE1UploadTemplateExcelData({ response: response, status: "success" }));
        yield put(globalLoaderText(""));
    } catch (error: any) {
        console.error('E1 Upload Template Export Error:', error?.message || error);
        
        yield put(globalLoaderText(""));
        yield put(setE1UploadTemplateExcelData({ response: {}, status: "failed" }));
    }
}

function* watchBulkOrder() {
    yield takeEvery(GET_REPORT_LIST, getReportListSaga)
    yield takeEvery(SAVE_LINK, saveLink)
    yield takeEvery(DELETE_LINK, deleteReportLink)
    yield takeEvery(SAVE_CATEGORY, saveLink)
    yield takeEvery(GET_E1_UPLOAD_TEMPLATE_EXCEL_DATA, getE1UploadTemplateExcelSaga) 
}

export default function* combinedSaga() {
    yield all([
        watchBulkOrder()
    ])
}
